"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useButtonCss = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_2 = require("@emotion/react");
var material_1 = require("@mui/material");
var icons_1 = require("./icons");
function useButtonCss(_a) {
    var outlined = _a.outlined;
    var theme = (0, material_1.useTheme)();
    var isSmallScreen = (0, material_1.useMediaQuery)(theme.breakpoints.down('md'));
    return (0, react_2.css)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: isSmallScreen ? 'center' : 'flex-start',
        height: 45,
        paddingLeft: 30,
        paddingRight: 30,
        fontSize: 20,
        color: outlined ? theme.palette.secondary.main : 'white',
        backgroundColor: outlined ? 'white' : theme.palette.secondary.main,
        border: outlined ? '1px solid' : 'none',
        borderColor: outlined ? theme.palette.secondary.main : 'initial',
        borderRadius: 50,
        cursor: 'pointer',
        textDecoration: 'none',
        fontFamily: 'TTNorms, sans-serif',
        fontWeight: 'bold',
    });
}
exports.useButtonCss = useButtonCss;
function Button(_a) {
    var _b = _a.endIcon, endIcon = _b === void 0 ? 'arrow' : _b, _c = _a.outlined, outlined = _c === void 0 ? false : _c, children = _a.children, props = __rest(_a, ["endIcon", "outlined", "children"]);
    var buttonCss = useButtonCss({ outlined: outlined });
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ type: "button", css: buttonCss }, props, { children: [children, endIcon === 'arrow' ? (0, jsx_runtime_1.jsx)(icons_1.ArrowRightIcon, { css: { marginLeft: 8, stroke: 'white' } }) : endIcon] })));
}
exports.default = Button;
